<template>
  <v-container fill-height fluid>
    <v-layout justify-center wrap>
      <material-card
        width="960px"
        title="Create new EMN user"
        :text="'for protocol ' + protocolName"
        color="primary"
        class="elevation-1"
      >
        <v-form ref="form" v-model="validForm" v-if="protocol_check">
          <v-flex md12 text-center>
            <img
              width="250px"
              :src="logo"
              style="padding: 10px; text-align: center"
            />
          </v-flex>

          <v-stepper v-model="stepper">
            <v-stepper-header>
              <v-stepper-step :complete="stepper > 1" step="1">
                Choose user profile
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="stepper > 2" step="2">
                Choose platforms
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="stepper > 3" step="3">
                Insert user data
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="stepper == 4" step="4">
                Finish!!!
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-select
                        id="input_user_profile_group"
                        clearable
                        md4
                        v-model="user_profile_group"
                        :items="availablesGroups"
                        label="User profile group"
                        item-text="name"
                        item-value="id"
                        @input="item.user_profile = null"
                      ></v-select>
                    </v-flex>

                    <v-flex
                      md12
                      text-left
                      style="font-size: 1em"
                      v-if="user_profile_group"
                    >
                      <div
                        v-for="profile in userProfiles"
                        v-bind:key="profile.id"
                      >
                        <b>{{ profile.name }}</b>: 
                        <span v-html="profile.description" />
                        <br /><br />
                      </div>
                    </v-flex>

                    <v-flex xs12 sm12 md12 v-if="user_profile_group">
                      <br />
                      <v-select
                        id="input_protocol_roles_id"
                        clearable
                        md4
                        v-model="item.protocol_roles_id"
                        :items="userProfiles"
                        label="User profile"
                        placeholder="Choose User profile"
                        item-value="id"
                        item-text="name"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 text-right>
                      <v-btn
                        id="button_continue1"
                        class="mx-1 font-weight-light"
                        color="success"
                        @click="stepper = 2"
                        :disabled="!item.protocol_roles_id"
                        >Continue >></v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12 text-center>
                      <v-combobox
                        id="input_platforms"
                        multiple
                        chips
                        clearable
                        label="Platforms"
                        v-model="platforms"
                        item-value="id"
                        item-text="label"
                        :return-object="false"
                        :items="availablePlatforms"
                      ></v-combobox>
                    </v-flex>

                    <v-flex xs12 text-right>
                      <v-btn
                        id="button_cancel2"
                        class="mx-1 font-weight-light"
                        color="success"
                        @click="stepper = 1"
                        >Cancel</v-btn
                      >

                      <v-btn
                        id="button_continue2"
                        class="mx-1 font-weight-light"
                        color="success"
                        @click="stepper = 3"
                        :disabled="!platforms.length"
                        >Continue >></v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md6 text-center>
                      <v-text-field
                        id="input_first_name"
                        label="First name"
                        :disabled="!isNew"
                        v-model="item.first_name"
                        :rules="validators.account.first_name"
                      ></v-text-field>
                    </v-flex>

                    <v-flex md6 text-center>
                      <v-text-field
                        id="input_last_name"
                        label="Last name"
                        :disabled="!isNew"
                        v-model="item.last_name"
                        :rules="validators.account.last_name"
                      ></v-text-field>
                    </v-flex>

                    <v-flex md6 text-center>
                      <v-text-field
                        id="input_email"
                        label="Email"
                        :disabled="!isNew"
                        v-model="item.email"
                        :rules="validators.account.email"
                      ></v-text-field>
                    </v-flex>

                    <v-flex md6 text-center>
                      <v-text-field
                        id="input_phone"
                        label="Phone"
                        :disabled="!isNew"
                        v-model="item.phone"
                        :rules="validators.account.phone"
                      ></v-text-field>
                    </v-flex>

                    <v-flex md3 text-center v-if="user_profile_group=='Site staff'">
                      <v-autocomplete
                        id="input_country_code"
                        label="Country"
                        :items="countries"
                        :disabled="!isNew"
                        v-model="item.country_code"
                        :rules="validators.account.country"
                        item-value="code"
                        item-text="name"
                        clearable
                        @change="selected_country = item.country_code"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex md9 text-center v-if="user_profile_group=='Site staff'">
                      <v-autocomplete
                        id="input_site_id"
                        :items="sites"
                        label="Site"
                        :disabled="!isNew"
                        v-model="item.site_id"
                        return-object
                        :rules="validators.account.site_id"
                        clearable
                        item-value="id"
                        item-text="factor_label"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex md6 text-center v-if="user_profile_group!='Site staff'">
                      <v-text-field
                        id="input_city"
                        label="City"
                        :disabled="!isNew"
                        v-model="item.city"
                        :rules="validators.account.city"
                        clearable
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-textarea
                        id="input_comment"
                        label="Comments"
                        v-model="item.comment"
                        rows="2"
                        clearable
                      ></v-textarea>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      In compliance with the European General Data Protection
                      Regulation (GDPR) n. 2016/679, I hereby authorize EMN
                      Trial Office to use and process my personal details
                      contained in this document.
                      <a :href="gdprLink" target="_blank"
                        >Please read the GDPR</a
                      >
                      <v-checkbox
                        id="input_privacy_agree"
                        label="I Agree"
                        v-model="item.privacy_agree"
                        :rules="validators.account.privacy"
                      ></v-checkbox>
                    </v-flex>

                    <v-flex xs12 text-right>
                      <v-btn
                        id="button_cancel3"
                        class="mx-1 font-weight-light"
                        color="success"
                        @click="stepper = 2"
                        >Cancel</v-btn
                      >

                      <v-btn
                        id="button_save"
                        class="mx-1 font-weight-light"
                        color="success"
                        :disabled="!validForm"
                        @click="save()"
                        >Save</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-stepper-content>

              <v-stepper-content step="4">
                <v-container grid-list-md>
                  <v-layout wrap id="result">
                    The user will be created by EMN Data Center. <br />
                    You'll receive a confirmation e-mail from {{ fromEmail }}
                    <br /><br />

                    Have a nice day!<br />
                  </v-layout>
                </v-container>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-form>

        <div v-if="!protocol_check && !loading">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                Something was wrong!!! Please check protocol id, Name, Provider and Activators.
              </v-flex>
            </v-layout>
          </v-container>
        </div>

        <div v-if="loading">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12> Loading data... </v-flex>
            </v-layout>
          </v-container>
        </div>
      </material-card>
    </v-layout>
  </v-container>
</template>

<script>
const { upsert, getList, get } = require("@/api/base_entity");
import _ from "lodash";
import validators from "@/utils/validators";

export default {
  data() {
    return {
      loading: false,
      stepper: 1,
      validators,
      validForm: true,
      countries: [],
      protocol: {},
      platforms: [],
      sites: [],
      roles: [],
      protocol_sites_id: [],
      protocol_check: false,
      profile_groups: [
        {
          id: "Site staff",
          name: "Site staff (Data-Manager,  Sub-Investigator, Principal Investigator)",
        },
        { id: "Laboratory", name: "Laboratory (Lab user, Supervisor)" },
        { id: "Other", name: "Other (Monitor, Statistician, Read only)" },
      ],
      // profiles: [
      //   {id:1, profiles: ['Principal Investigator (PI)', 'Sub-Investigator (SI)', 'Data-Manager (DM)', 'Pharmacist']},
      //   {id:2, profiles: ['FISH lab user', 'NGF lab user', 'FISH and NGF lab user', 'Supervisor FISH', 'Supervisor NGF', 'Supervisor FISH and NGF']},
      //   {id:3, profiles: ['Monitor', 'Statistician', 'Read only']},
      // ],
      user_profile_group: null,
      item: { user_profile: null },
      selected_country: null,
    };
  },
  computed: {
    userProfileObj() {
      const up = this.userProfiles.filter( el => { return el.id == this.item.protocol_roles_id})
      if(up.length) {
        return up[0]
      }
      return []
    },
    availablePlatforms() {

      let platforms = []

      if(this.userProfileObj.redcap_map) {
        platforms.push({id:'REDCap', label:'eCRF'})
      }

      if(this.userProfileObj.safety_map) {
        platforms.push({id:'SafetyDB', label:'SafetyDB'})
      }

      if(this.userProfileObj.ecds_map) {
        platforms.push({id:'eCDS', label:'eCDS'})
      }

      // if(this.userProfileObj.logistic_map) {
      //   platforms.push({id:'EMN Logistic', label:'EMN Logistic'})
      // }

      return platforms
    },
    logo() {

      const arrMap = {
        1: "/img/logo_emn_trial_office.svg",
        2: "/img/logo_fonesa.png",
        3: "/img/logo_emn_trial_office.svg",
        4: "/img/logo_emnintl.png",
      }

      return arrMap[this.protocol.sponsor_id];

    },
    gdprLink() {

      const arrMap = {
        1: "https://www.emntrialoffice.org/en-UK/contact_us/ecrf_user_registration_privacy?Uid=07D307D9",
        2: "https://www.emnitaly.org/en-UK/help_us/ecrf_user_registration_privacy?Uid=07D307D7",
        3: "https://www.emntrialoffice.org/en-UK/contact_us/ecrf_user_registration_privacy?Uid=07D307D9",
        4: "https://www.myeloma-europe.org/user-registration-privacy/",
      }

      return arrMap[this.protocol.sponsor_id];

    },
    isNew() {
      return this.item.id ? false : true;
    },
    protocolName() {
      return this.protocol.name;
    },
    userProfiles() {
      if (!this.user_profile_group) return [];
      return this.roles.filter((r) => r.group_name == this.user_profile_group);
    },
    availablesGroups() {
      const unique = [...new Set(this.roles.map(item => item.group_name))];
      return this.profile_groups.filter( el => unique.indexOf(el.id) != -1 )
    },
    fromEmail() {
      const arrMap = {
        1: "datacenter@emnresearch.it",
        2: "datacenter@emnitaly.org",
        3: "datacenter@emnresearch.it",
        4: "datacenter@emntrials.org",
      }

      return arrMap[this.protocol.sponsor_id];
    },
  },

  mounted() {
    this.checkProtocol().then(() => {
      this.getCountries();
      this.getRoles();
    });
  },
  watch: {
    $route() {
      this.checkProtocol().then(() => {
        this.getCountries();
        this.getRoles();
      });
    },
    selected_country($v) {
      if (!$v) {
        this.sites = [];
        return [];
      }
      this.getSites();
    },
  },
  methods: {
    checkProtocol() {
      this.loading = true;
      this.protocol_check = false;
      return get("public/protocol/" + this.$route.params.uuid)
        .then((ret) => {
          this.protocol = ret;
          if (this.protocol && (this.protocol.account_activators.length || this.protocol.email_activators.length)) {
            this.protocol_check = true;
          }
          this.item.protocol_id = this.protocol.id;
          this.item.status = "New";
          this.item.platforms = [];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async getCountries() {
      const retPS = await getList(
        "public/protocol_has_site",
        { protocol_id: this.protocol.id },
        { rowsPerPage: -1 }
      );
      this.protocol_sites_id = retPS.data.map((r) => {
        return r.site_id;
      });
      const retS = await getList(
        "public/site",
        { id: this.protocol_sites_id },
        { rowsPerPage: -1 }
      );
      const cCodes = Object.keys(_.groupBy(retS.data, "country_code"));
      const retC = await getList(
        "public/country",
        { code: cCodes },
        { rowsPerPage: -1 }
      );
      this.countries = retC.data;
    },
    async getSites() {
      const ret = await getList(
        "public/site",
        { id: this.protocol_sites_id, country_code: this.selected_country },
        { rowsPerPage: -1 }
      );
      this.sites = ret.data;
    },
    async getRoles() {
      const ret = await getList(
        "public/roles",
        { protocol_id: this.protocol.id },
        { rowsPerPage: -1 }
      );
      this.roles = ret.data;
    },
    async save() {
      if(this.item.site_id) {
        this.item.sites = [this.item.site_id];
      }
      this.item.platforms = this.platforms;
      upsert("public/user", this.item).then(() => {
        this.stepper = 4;
      });
    },
  },
};
</script>
